import { AxiosInstance } from 'axios';
import { thermalPrinterUrl } from 'keys';
import { FrameworkDefaultAxiosInstance } from 'framework/xhr/FrameworkDefaultAxiosInstance';

export const DefaultAxiosInstance = (): AxiosInstance => {
	return FrameworkDefaultAxiosInstance(thermalPrinterUrl);
};
